export function coupangLink(value) {
  if (typeof value !== 'string' || !value.trim()) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password) return null;
    if (!['link.coupang.com', 'www.coupang.com', 'coupang.com'].includes(url.hostname)) return null;
    return url.href;
  } catch (_) { return null; }
}
